// ModalReuse.js
import modalStyles from "./ModalRes.module.css";

import { IoClose } from "react-icons/io5";

export const ModalReuse = ({ isOpen, onClose, content, hideCloseButton = false }) => {
  if (!isOpen) return null;

  return (
    <div className={modalStyles.modalOverlay}>
      <div className={modalStyles.modal}>
        {!hideCloseButton && (
          <button className={modalStyles.closeButton} onClick={onClose}>
            <IoClose size={20} />
          </button>
        )}
        <div className={modalStyles.modalContent}>{content}</div>
      </div>
    </div>
  );
};
